/**
 * Several components mount at once and ask for the same data (the right bar
 * is rendered three times on a Lounge page; two components load the user
 * menu). Callers with the same key share one in-flight request, and the
 * result is reused for `ttlMs`. Failures are not cached.
 */
type Entry = { promise: Promise<any>; expires: number };

const cache = new Map<string, Entry>();

export const sharedRequest = <T,>(
  key: string,
  ttlMs: number,
  request: () => Promise<T>
): Promise<T> => {
  const now = Date.now();
  const hit = cache.get(key);
  if (hit && hit.expires > now) return hit.promise;

  const promise = request().catch((err) => {
    cache.delete(key);
    throw err;
  });
  cache.set(key, { promise, expires: now + ttlMs });
  return promise;
};

/** For tests. */
export const clearSharedRequests = () => cache.clear();
